import React from "react";

function Pnf(){
    return(
        <div className="container">
            <div className="row">
                <div className="col-md12 text-center">
                    <h3 className="display-3 text-secondary">Page not found</h3>
                </div>
            </div>
        </div>
    )
}
export default Pnf